import { Box, Typography } from '@mui/material';
import { MDBox } from '../../../../Component/Common/Components/MDBox';

export const EmpowermentFinancingTransformationalInfrastructure = () => {
    return (
        <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
            <MDBox style={{ padding: '10px' }}>
                <Typography variant="body1">Coming soon.</Typography>
            </MDBox>
        </Box>
    );
};
